<script>
import { required, integer, minValue, maxValue } from 'vuelidate/lib/validators'

export default {
  name: 'pkf-form',
  props: {
    value: { type: Object, default: () => {} }
  },

  data: vm => ({
    form: {
      specs: {
        wheel_size: null,
        color: null,
        table_system: 'front',
        tube_length: 80
      },
      ...vm.value
    }
  }),
  computed: {
    colors () {
      return [
        { value: null, text: '- Select a Color -' },
        { value: 'titan', text: this.$t('attribute.color.titan') },
        { value: 'blue', text: this.$t('attribute.color.blue') }
      ]
    },
    wheel_sizes () {
      return [
        { value: null, text: '- Select a Wheel Size -' },
        {
          value: 24,
          text: this.$t('attribute.wheel_size.value', { value: 24 })
        },
        {
          value: 26,
          text: this.$t('attribute.wheel_size.value', { value: 26 })
        },
        {
          value: 28,
          text: this.$t('attribute.wheel_size.value', { value: 28 })
        },
        {
          value: 30,
          text: this.$t('attribute.wheel_size.value', { value: 30 })
        },
        {
          value: 32,
          text: this.$t('attribute.wheel_size.value', { value: 32 })
        },
        {
          value: 34,
          text: this.$t('attribute.wheel_size.value', { value: 34 })
        }
      ]
    }
  },

  validations: {
    form: {
      specs: {
        wheel_size: {
          required
        },
        color: {
          required
        },
        tube_length: {
          required,
          integer,
          minValue: minValue(50),
          maxValue: maxValue(115)
        }
      }
    }
  },
  methods: {
    validate () {
      if (!this.$v && !this.$v.form) return true
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.$emit('validated', { ...this.form })
        this.$emit('input', { ...this.form })
      }

      return !this.$v.form.$invalid
    }
  }
}
</script>
<template>
  <b-row>
    <b-col cols="12">
      <g-form-error-wrapper :validations="$v.form.specs.wheel_size">
        <template v-slot="{ errors, invalid }">
          <g-select
            v-model="form.specs.wheel_size"
            :label="$t('Wheel Size')"
            maxWidth="230px"
            :options="wheel_sizes"
            :error-messages="errors"
            :is-valid="!invalid"
            v-on:blur="$v.form.specs.wheel_size.$touch()"
            label-cols-sm="6"
            label-cols-lg="6"
          >
          </g-select>
        </template>
      </g-form-error-wrapper>
      <g-form-error-wrapper :validations="$v.form.specs.color">
        <template v-slot="{ errors, invalid }">
          <g-select
            v-model="form.specs.color"
            :label="$t('Color')"
            maxWidth="230px"
            :options="colors"
            :error-messages="errors"
            :is-valid="!invalid"
            v-on:blur="$v.form.specs.color.$touch()"
            label-cols-sm="6"
            label-cols-lg="6"
          >
          </g-select>
        </template>
      </g-form-error-wrapper>

      <g-select
        v-model="form.specs.table_system"
        :label="$t('Table System')"
        maxWidth="250px"
        :options="[
          { value: 'front', text: 'Yes, Add a table System' },
          { value: 'no', text: 'No Table System' }
        ]"
        label-cols-sm="6"
        label-cols-lg="6"
      >
      </g-select>

      <g-form-error-wrapper :validations="$v.form.specs.tube_length">
        <template v-slot="{ errors, invalid }">
          <g-text-input
            v-model.number="form.specs.tube_length"
            :label="$t('Patient Tube Length')"
            append="cm"
            maxWidth="100px"
            text-align="center"
            :error-messages="errors"
            :is-valid="!invalid"
            v-on:blur="$v.form.specs.tube_length.$touch()"
            label-cols-sm="6"
            label-cols-lg="6"
          >
          </g-text-input>
        </template>
      </g-form-error-wrapper>

      <label for="comments">{{ $t('comments') }}</label>
      <b-form-textarea
        id="comments"
        :placeholder="$t('extra comments or requirements')"
        v-model="form.comments"
        rows="4"
        max-rows="4"
      />
    </b-col>
  </b-row>
</template>
